<template>
  <div class="table-responsive">
    <el-table border :data="data" class="el-table-css" style="width: 100%">
      <el-table-column prop="subrogationNumber" label="Subroqasiya №" width="180">
        <template #default="scope">
          <a href="javascript:void(0)" style="color: #409eff; text-decoration: underline;"
            @click="openSubrogation(scope.row.subrogationId)">
            {{ scope.row.subrogationNumber }}
          </a>
        </template>
      </el-table-column>
      <el-table-column prop="stageLabel" label="Mərhələ" width="200" />
      <el-table-column prop="defendant" label="Cavabdeh" width="300" />
      <el-table-column prop="debt" label="Borc" width="200">
        <template #default="scope">
          {{ formatAmount(scope.row.debt) }}
        </template>
      </el-table-column>
      <el-table-column prop="totalDebt" label="Ümumi borc" width="181">
        <template #default="scope">
          {{ formatAmount(scope.row.totalDebt) }}
        </template>
      </el-table-column>
      <el-table-column prop="date" label="Tarix" width="150">
        <template #default="scope">
          {{ formatDate(scope.row.date) }}
        </template>
      </el-table-column>
      <el-table-column prop="phone" label="Əlaqə nömrəsi" width="204">
        <template #default="scope">
          <span>{{ scope.row.phone }}</span>
          <el-button class="fs-5 ms-2" type="text" style="padding: 0 !important;" :icon="Message" title="SMS göndər"
            @click="$emit('sms', scope.row)">
          </el-button>
        </template>
      </el-table-column>

      <el-table-column prop="lastSmsDate" label="SMS göndərilmə tarixi" width="180">
        <template #default="scope">
          {{ formatDateTime(scope.row.lastSmsDate) }}
        </template>
      </el-table-column>

    </el-table>
    <div class="d-flex justify-content-start mt-3">
      <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize" :current-page="page"
        @current-change="$emit('page-change', $event)" />
    </div>
  </div>
</template>

<script>
import { Message } from "@element-plus/icons-vue";

export default {
  props: {
    data: { type: Array, required: true },
    total: { type: Number, required: true },
    pageSize: { type: Number, required: true },
    page: { type: Number, required: true }
  },
  data() {
    return {
      Message
    };
  },
  methods: {
    formatDate(dt) {
      if (!dt) return "-";
      const d = new Date(dt);
      const dd = String(d.getDate()).padStart(2, '0');
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const yyyy = d.getFullYear();
      return `${dd}.${mm}.${yyyy}`;
    },
    formatDateTime(dt) {
      if (!dt) return "-";
      const d = new Date(dt);
      const dd = String(d.getDate()).padStart(2, '0');
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const yyyy = d.getFullYear();
      const hh = String(d.getHours()).padStart(2, '0');
      const min = String(d.getMinutes()).padStart(2, '0');
      return `${dd}.${mm}.${yyyy} ${hh}:${min}`;
    },

    formatAmount(value) {
      if (value == null) return "-";
      let parts = Number(value).toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return parts.join(',');
    },
    openSubrogation(id) {
      const route = this.$router.resolve({
        name: "Subroqasiya - Məlumat",
        params: { id }
      });
      window.open(route.href, "_blank");
    }
  }

}

</script>

<style scoped></style>
